<template>
  <footer class="app-footer">
    <span>
      &copy; {{ new Date().getFullYear() }}
      <a id="footer-link-nanome" href="https://nanome.ai/">Nanome</a>
    </span>
    <span class="ml-3">
      <a href="https://docs.nanome.ai" target="_blank">Docs</a>
    </span>
  </footer>
</template>
<script>
export default {
  name: "c-footer"
};
</script>
